import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

import SignUpPage from './signUpPage'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { RigipsStore } from 'redux/redux'

const mapStateToProps = (state: RigipsStore) => {
  const { auth } = state
  const { authenticated } = auth

  return { authenticated }
}

export type InputProps = {
  company: string
  companyType: string
  street: string
  zipCode: string
  city: string
  country: string
  webAdress: string
  employeeCount: number
  sex: string
  firstname: string
  lastname: string
  phone: string
  fax: string
  email: string
  termsOfUse: boolean
  newsletter: boolean
  dealer: string
}

export type Variables = {
  company: string
  companyType: string
  street: string
  zipCode: string
  city: string
  country: string
  webAdress: string
  employeeCount: number
  sex: string
  firstname: string
  lastname: string
  phone: string
  fax: string
  email: string
  termsOfUse: boolean
  newsletter: boolean
  dealer: string
}

const USER_MUTATION = gql`
  mutation registerUser(
    $company: String!
    $companyType: String!
    $street: String!
    $zipCode: String!
    $city: String!
    $country: String!
    $webAdress: String
    $employeeCount: Float
    $sex: String!
    $firstname: String!
    $lastname: String!
    $phone: String!
    $fax: String
    $email: String!
    $termsOfUse: Boolean
    $newsletter: Boolean
    $dealer: String
  ) {
    registerUser(
      company: $company
      companyType: $companyType
      street: $street
      zipCode: $zipCode
      city: $city
      country: $country
      webAdress: $webAdress
      employeeCount: $employeeCount
      sex: $sex
      firstname: $firstname
      lastname: $lastname
      phone: $phone
      fax: $fax
      email: $email
      termsOfUse: $termsOfUse
      newsletter: $newsletter
      dealer: $dealer
    )
  }
`

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const withUserMutation = graphql<InputProps, Response, Variables, ChildProps>(USER_MUTATION)

export default withUserMutation(connect(mapStateToProps)(withRouter(SignUpPage)))
